"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { useSearchParams } from "next/navigation";
import { LoaderCircle, Search } from "lucide-react";
import { useRef, useTransition } from "react";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
export const SearchBar = () => {
  const $ = _c(17);
  const router = useRouter();
  const searchParams = useSearchParams();
  const inputRef = useRef(null);
  const [isLoading, startTransition] = useTransition();
  let t0;
  if ($[0] !== router) {
    t0 = event => {
      event.preventDefault();
      if (inputRef.current?.value === "") {
        return;
      }
      const searchQuery = new URLSearchParams();
      searchQuery.set("query", inputRef.current.value);
      router.push("/search?" + searchQuery.toString(), {
        scroll: false
      });
      if (window.location.pathname.startsWith("/search")) {
        router.refresh();
      }
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSubmit = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("query") ?? "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="w-40"><Input ref={inputRef} className="rounded-r-none border-r-0 focus-visible:ring-0" placeholder={"T\xECm ki\u1EBFm"} type="text" name="query" defaultValue={t1} /></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleSubmit) {
    t3 = e => startTransition(() => handleSubmit(e));
    $[6] = handleSubmit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isLoading) {
    t4 = isLoading ? <LoaderCircle size={20} className="animate-spin" /> : <Search size={20} />;
    $[8] = isLoading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isLoading || $[11] !== t3 || $[12] !== t4) {
    t5 = <Button size="icon" variant="outline" type="submit" className="rounded-l-none" disabled={isLoading} onClick={t3}>{t4}</Button>;
    $[10] = isLoading;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t5) {
    t6 = <form className="flex w-max rounded-md focus-within:outline focus-within:outline-offset-2 focus-within:outline-ring">{t2}{t5}</form>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};